import React from 'react';
import { withShowable } from '../console/_global/lib/withShowable';

const Showable = withShowable(React.Fragment);

export default Showable;
